export default __webpack_public_path__ + "static/media/ReleaseNotes_Content_Estimatedmiles.17308f7a.jpg";